import { render, staticRenderFns } from "./PaxImport.vue?vue&type=template&id=4db3fc2d&scoped=true&"
import script from "./PaxImport.vue?vue&type=script&lang=js&"
export * from "./PaxImport.vue?vue&type=script&lang=js&"
import style0 from "./PaxImport.vue?vue&type=style&index=0&id=4db3fc2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db3fc2d",
  null
  
)

export default component.exports